import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';

export const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '65px',
    boxSizing: 'border-box',
    gap: '24px',
    flexWrap: 'wrap',
    overflow: 'hidden',
    width: '100%',
    marginBottom: '32px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: '16px',
      height: '40px',
      gap: 2,
      padding: 0,
    },

    svg: {
      fill: '#71717A',
      height: '17px',
      width: '17px',
    },
  },
  header: {
    color: '#71717A',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '1.2',
    marginRight: '24px',
    minWidth: '100px',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      minWidth: 'inherit',
      fontSize: '16px',
      marginRight: '16px',
    },
  },
  logo: (withRadius: boolean) => ({
    maxWidth: '88px',
    maxHeight: '56px',
    height: '100%',
    objectFit: 'contain',
    ...(withRadius && { borderRadius: '3px' }),
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      width: 'auto',
      maxWidth: '48px',
      maxHeight: '40px',
    },
  }),
};
